module.exports = __webpack_public_path__ + "static/media/olho.e9856ff3.png";